module.exports = __webpack_public_path__ + "img/email.eaa9fff3.svg";